<template>
  <div class="index">
    <div class="content">
      <div class="about">
        <!-- <div class="about-left">
          <img
            src="../../assets/image/about.png"
            alt=""
          >
        </div> -->
        <div class="about-right">
          <div class="text">
            邮政编码：518000
          </div>
          <div class="text">
            邮箱地址：ysdb@eptok.com
          </div>
          <div class="text">
            传真号码：0755-29986799
          </div>
          <div class="text">
            服务热线：0755-29986683
          </div>
          <div class="text">
            公司地址：深圳市宝安区龙华新区大道997号远景大厦六楼
          </div>
          <!-- <a-button
            type="link"
            @click="$router.push('./brandintroduction')"
          >
            查看更多
          </a-button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {

  },
};
</script>
<style lang="less" scoped>
.index {
  display: flex;
  flex-direction: column;
  height: 780px;
  background-color: #f2f2f2;
}
.content {
  width: 1200px;
  height: 700px;
  margin: 0 auto;
  background: #ffff;
  margin-top: 50px;
}
.about {
  // display: flex;
  justify-content: center;
  padding-top: 60px;
  .about-left {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
    }
  }
  .about-right {
    position: relative;
    .text {
      text-align: justify;
      margin-left: 100px;
      // width: 670px;
      text-indent: 2em;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666;
      line-height: 100px;
    }
    ::v-deep .ant-btn {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 96px;
      height: 40px;
      border: 1px solid #ddd;
      border-radius: 20px;
      font-size: 0.875rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999;
      background-color: #fff;
      cursor: pointer;
      transition: all 0.5s;
    }
  }
}
</style>
